<template>
  <div id="app">
    <Example></Example>
  </div>
</template>

<script>
import Example from './components/map.vue'

export default {
  name: 'App',
  components: {
    Example
  },
}
</script>

<style>

#app .leaflet-bottom{
  z-index: 450;
}


/* #app .vm2_modal-content{
  left: -300px;
  top: -300px;
} */

#app .vm2_settings {
max-width: 550px;
}

#app .vm2_body {
  text-align: justify;
  margin-left: 22px;
  margin-right: 22px;
  margin-bottom: 12px;

}

#app #vm2_box_modal-1{
  top: -35%
}
#app #vm2_box_modal-2{
  top: -25%
}
#app #vm2_box_modal-3{
  top: -35%
}
#app #vm2_box_modal-4{
  top: -35%
}


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

#app body {
  zoom: 90%;
}

.multiselect__option--selected {
background-color: darkslategray;
color: white;
}

#app .leaflet-top, .leaflet-bottom {
    z-index: 400;
}
#app .leaflet-draw-actions a {
  background-color: wheat ;
}

#app .leaflet-touch .leaflet-bar a {
    width: 40px;
    height: 40px;
    line-height: 40px;
}
.leaflet-touch .leaflet-right .leaflet-draw-actions {
    right: 39px;
    left: auto;
}
.leaflet-touch .leaflet-draw-actions a {
    font-size: 12px;
    line-height: 40px;
    height: 40px;
}

#app .leaflet-touch .leaflet-bar button {
    width: 40px;
    height: 40px;
    line-height: 40px;
}

.js-plotly-plot .plotly .modebar-btn {
    font-size: 30px !important;
}


</style>
